<div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
    <mat-spinner diameter="100"></mat-spinner>
    <h2 class="mt-4 white">Mise à jour des données en cours ...</h2>
</div>